import AudioView from 'iovisit-astermantova/components/Views/AudioView';

export const IoVisitViews = (config) => {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    WildcardAudio: AudioView,
  };
};
